import React from 'react';

interface CardProps {
  title?:    React.ReactNode;
  sub?:      React.ReactNode;
  action?:   React.ReactNode;
  children:  React.ReactNode;
  pad?:      boolean;
  className?: string;
}

export const Card: React.FC<CardProps> = ({ title, sub, action, children, pad = true, className = '' }) => (
  <div className={`card ${className}`}>
    {(title || action) && (
      <div className="card-head">
        <div>
          {title && <h3>{title}</h3>}
          {sub && <div className="sub">{sub}</div>}
        </div>
        {action}
      </div>
    )}
    <div className={pad ? 'card-pad' : ''}>{children}</div>
  </div>
);
